const objectToGetParams = (object: any = {}): string => {
  const params = Object.entries(object)
    .filter(([, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);

  return params.length > 0 ? `?${params.join('&')}` : '';
};

export const facebookShareUrl = (url: string, title?: string, hashtag?: string): string => {
  return `https://www.facebook.com/sharer/sharer.php${objectToGetParams({
    u: url,
    quote: title,
    hashtag,
    display: 'page',
  })}`;
};

export const twitterShareUrl = (url: string, title: string): string => {
  return `https://twitter.com/share${objectToGetParams({
    url,
    text: title,
  })}`;
};

export const waShareUrl = (url: string): string => {
  return `https://api.whatsapp.com/send${objectToGetParams({
    text: url,
  })}`;
};

export const emailShareUrl = (url: string, subject: string, body: string): string => {
  return `mailto:${objectToGetParams({ subject, body: body ? `${body}\n\n\n${url}` : url })}`;
};

export const pinterestShareUrl = (url: string, media: string, title: string): string => {
  return `https://pinterest.com/pin/create/button/${objectToGetParams({
    url,
    description: title,
    media,
  })}`;
};
